import { render, staticRenderFns } from "./EducationCourses.vue?vue&type=template&id=431d9948"
import script from "./EducationCourses.vue?vue&type=script&lang=js"
export * from "./EducationCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports